import { OVERLAY_Z_INDEX_CEILING } from "./eva-z-layers";

export interface EvaModalLayer {
  currentZIndex: number;
  closeFromEscape(): void;
}

const EVA_MODAL_BASE_Z_INDEX = 11000;

// Modales seulement : compter les dropdowns ouverts ferait passer les suivants sous la dialog.
const OTHER_MODALS_SELECTOR = ".p-dialog-mask, .p-sidebar";

const openModals: EvaModalLayer[] = [];

let removeEscapeListener: (() => void) | null = null;

function onEscape(event: KeyboardEvent): void {
  if (event.key !== "Escape" || !openModals.length) return;
  event.stopPropagation();
  if (event.defaultPrevented) return;
  event.preventDefault();
  openModals[openModals.length - 1].closeFromEscape();
}

// Sur <body> : passe avant les écouteurs document (p-dialog, p-sidebar) qui fermeraient le dessous.
// Retiré quand la pile se vide : zone.js fige l'écouteur dans la zone de son ajout.
export function registerModal(layer: EvaModalLayer, doc: Document): void {
  openModals.push(layer);
  if (removeEscapeListener) return;
  const body = doc.body;
  body.addEventListener("keydown", onEscape);
  removeEscapeListener = () => body.removeEventListener("keydown", onEscape);
}

export function unregisterModal(layer: EvaModalLayer): void {
  const index = openModals.indexOf(layer);
  if (index !== -1) openModals.splice(index, 1);
  if (!openModals.length && removeEscapeListener) {
    removeEscapeListener();
    removeEscapeListener = null;
  }
}

/** Vrai si une eva-dialog ou un eva-drawer est ouvert : les autres écouteurs d'Escape doivent le laisser gérer. */
export function hasOpenEvaModal(): boolean {
  return openModals.length > 0;
}

/** Retourne un z-index au-dessus des modales ouvertes (eva-dialog, eva-drawer, p-sidebar). */
export function nextModalZIndex(layer: EvaModalLayer, host: HTMLElement, doc: Document): number {
  let maxZIndex = EVA_MODAL_BASE_Z_INDEX;

  openModals.forEach((other) => {
    if (other !== layer) maxZIndex = Math.max(maxZIndex, other.currentZIndex);
  });

  doc.querySelectorAll<HTMLElement>(OTHER_MODALS_SELECTOR).forEach((element) => {
    if (host.contains(element)) return;

    const zIndex = Number.parseInt(window.getComputedStyle(element).zIndex, 10);
    if (!Number.isNaN(zIndex) && zIndex > maxZIndex && zIndex < OVERLAY_Z_INDEX_CEILING) {
      maxZIndex = zIndex;
    }
  });

  return maxZIndex + 1;
}
